export default "__VITE_ASSET__b6a7804f__"